"use strict";

var _regeneratorRuntime = require("/var/www/dev/prosper/admin.samsung-prosper.dev.pannovate.net/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _urlParse = _interopRequireDefault(require("url-parse"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Config = {
  env: process.env.REACT_APP_ENVIRONMENT,
  url: process.env.REACT_APP_URL || ''
};
var env = Config.env || (!process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? 'dev' : 'live');
var publicUrl = new _urlParse["default"](Config.url).origin;
var common = {
  resetDB: false,
  disablePasscode: false,
  forceIntros: false,
  publicUrl: publicUrl,
  passcodeLength: 6,
  cardRatio: 1.56,
  physicalCardCost: 7.50,
  maxTopUpValue: 250,
  minTopUpValue: 10
};

var configuration = _objectSpread({}, common, {
  checkout_url: 'https://sandbox.checkout.com/api2/v2/tokens/card',
  checkout_public_key: 'pk_test_24166a6e-18f7-4405-b42a-d74aa75dc05d'
}, Config);

var config = _objectSpread({
  env: env
}, configuration, {
  cards: {
    cardPrice: {
      'GBP': 10
    }
  },
  topUp: {
    min: 10,
    max: 200
  },
  facebook: {},
  twitter: {},
  linkedin: {},

  /**
   * Merge data with current object
   *
   * @param {Object} result
   */
  merge: function () {
    var _merge = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(result) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              Object.assign(this, result);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function merge(_x) {
      return _merge.apply(this, arguments);
    }

    return merge;
  }()
});

var _default = config;
exports["default"] = _default;